import type React from "react";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../store";
import { useTranslation } from "react-i18next";
import type translations from "../translations/translations.json";
import { useResetPassword } from "../hooks/useResetPassword";
import ResetPasswordForm from "../components/ResetPasswordForm";
import FormLayout from "../components/common/FormLayout";
import type { AppDispatch } from "../store";
type TranslationKeys = keyof typeof translations.en;

const ResetPasswordPage: React.FC = () => {
  const userState = useSelector((state: RootState) => {
    return state.user;
  });
  const { user } = userState;
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();

  const { formData, loading, error, success, handleChange, handleSubmit } = useResetPassword({
    userId: user?._id || "",
  });

  if (!user) {
    return (
      <FormLayout title={t("Reset Password" as TranslationKeys)}>
        <Typography color="error">{t("User not found" as TranslationKeys)}</Typography>
      </FormLayout>
    );
  }

  return (
    <FormLayout
      title={t("Reset Password for {{username}} ({{name}})" as TranslationKeys, {
        username: user._id,
        name: user.name || "",
      })}
    >
      <ResetPasswordForm
        formData={formData}
        loading={loading}
        error={error}
        success={success}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </FormLayout>
  );
};

export default ResetPasswordPage;
